import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import Funcionalidad from "./Funcionalidad";
import Menu2Nivel from "./Menu2Nivel";
import TableroProyecto from "./TableroProyecto"
import CRUDproyecto from "./CRUDproyecto"
import Riesgos from "./Riesgos"
import Cambios from "./Cambios"
import Acciones from "./Acciones"
import Sprints from "./Sprints"
import Costos from "./Costos"
import cambios from "./img/cambios.png";
import riesgoIcon from "./img/riesgo.png";
import costos from "./img/costos.png";
import sprints from "./img/sprints.png";
import datosGenerales from "./img/datosGenerales.png";
import acciones from "./img/acciones.png";
import proyecto from "./img/proyecto.png"
import { clBasic } from "./general";

export default function AdminProyecto({ f }) {
  let { firebase, usrLogged } = useContext(AppContext);
  let activo = firebase.proyectoActivo.proyecto

  const [funcion, setFuncion] = useState(f ? f : "Proyecto");

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = activo.id + ": " + activo.nombre;
  }, [activo.id, activo.nombre]);

  if (usrLogged.isLogged)
    return (
      <div id="APprincipal" style={SadminProyecto}>
        <Menu2Nivel>
          {activo.tipo === "Agil" && <Funcionalidad setF={setFuncion} filtroIcon={sprints} funcion={"Planificar sprints"} />}
          <Funcionalidad setF={setFuncion} filtroIcon={proyecto} funcion={"Proyecto"} />
          <Funcionalidad setF={setFuncion} filtroIcon={datosGenerales} funcion={"Datos Generales"} />
          <Funcionalidad setF={setFuncion} filtroIcon={riesgoIcon} funcion={"Riesgos"} />
          <Funcionalidad setF={setFuncion} filtroIcon={cambios} funcion={"Cambios"} />
          <Funcionalidad setF={setFuncion} filtroIcon={acciones} funcion={"Acciones"} />
          <Funcionalidad setF={setFuncion} filtroIcon={costos} funcion={"Costos"} />
        </Menu2Nivel>

        <div style={SdatosGenerales}>
          {funcion === "Proyecto" && <TableroProyecto />}
          {funcion === "Datos Generales" && <CRUDproyecto />}
          {funcion === "Riesgos" && <Riesgos />}
          {funcion === "Cambios" && <Cambios />}
          {funcion === "Acciones" && <Acciones />}
          {funcion === "Planificar sprints" && <Sprints />}
          {funcion === "Costos" && <Costos />}
        </div>
      </div>)
  else return <div style={{ color: clBasic }}>Debe loguearse, gil!!</div>;
}

const SadminProyecto = {
  width: "100vw",
  height: "90vh",
  display: "flex",
  flexDirection: "row",
};

const SdatosGenerales = {
  width: "100%",
  height: "100%",
  position: "relative",
};
